import { useRef, useState } from 'react';

import { useDebouncedCallback } from './use-debounce-callback.hook';

export const useDebounce = <T>(value: T, delay = 250): T => {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);
	const previousValueRef = useRef<T | undefined>(value);

	const updateDebouncedValue = useDebouncedCallback(setDebouncedValue, delay);

	// Update the debounced value if the initial value changes
	if (value !== previousValueRef.current) {
		updateDebouncedValue(value);
		previousValueRef.current = value;
	}

	return debouncedValue;
};
